<template>
  <div class="animated fadeIn">
    <b-card no-body id="new47">
      <div slot="header">
        <i class="fa fa-font-awesome"></i> Flags
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col class="mb-5" cols="12">
            For using the flags inline with text add the classes <code>.flag-icon</code> and <code>.flag-icon-xx</code> (where xx is the ISO 3166-1-alpha-2 code of a country) to an empty span. If you want to have a squared version flag then add the class flag-icon-squared as well.
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ad h1" title="ad" id="ad"></i>
            <div>flag-icon-ad</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ae h1" title="ae" id="ae"></i>
            <div>flag-icon-ae</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-af h1" title="af" id="af"></i>
            <div>flag-icon-af</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ag h1" title="ag" id="ag"></i>
            <div>flag-icon-ag</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ai h1" title="ai" id="ai"></i>
            <div>flag-icon-ai</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-al h1" title="al" id="al"></i>
            <div>flag-icon-al</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-am h1" title="am" id="am"></i>
            <div>flag-icon-am</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ao h1" title="ao" id="ao"></i>
            <div>flag-icon-ao</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-aq h1" title="aq" id="aq"></i>
            <div>flag-icon-aq</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ar h1" title="ar" id="ar"></i>
            <div>flag-icon-ar</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-as h1" title="as" id="as"></i>
            <div>flag-icon-as</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-at h1" title="at" id="at"></i>
            <div>flag-icon-at</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-au h1" title="au" id="au"></i>
            <div>flag-icon-au</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-aw h1" title="aw" id="aw"></i>
            <div>flag-icon-aw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ax h1" title="ax" id="ax"></i>
            <div>flag-icon-ax</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-az h1" title="az" id="az"></i>
            <div>flag-icon-az</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ba h1" title="ba" id="ba"></i>
            <div>flag-icon-ba</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bb h1" title="bb" id="bb"></i>
            <div>flag-icon-bb</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bd h1" title="bd" id="bd"></i>
            <div>flag-icon-bd</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-be h1" title="be" id="be"></i>
            <div>flag-icon-be</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bf h1" title="bf" id="bf"></i>
            <div>flag-icon-bf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bg h1" title="bg" id="bg"></i>
            <div>flag-icon-bg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bh h1" title="bh" id="bh"></i>
            <div>flag-icon-bh</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bi h1" title="bi" id="bi"></i>
            <div>flag-icon-bi</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bj h1" title="bj" id="bj"></i>
            <div>flag-icon-bj</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bl h1" title="bl" id="bl"></i>
            <div>flag-icon-bl</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bm h1" title="bm" id="bm"></i>
            <div>flag-icon-bm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bn h1" title="bn" id="bn"></i>
            <div>flag-icon-bn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bo h1" title="bo" id="bo"></i>
            <div>flag-icon-bo</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bq h1" title="bq" id="bq"></i>
            <div>flag-icon-bq</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-br h1" title="br" id="br"></i>
            <div>flag-icon-br</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bs h1" title="bs" id="bs"></i>
            <div>flag-icon-bs</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bt h1" title="bt" id="bt"></i>
            <div>flag-icon-bt</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bv h1" title="bv" id="bv"></i>
            <div>flag-icon-bv</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bw h1" title="bw" id="bw"></i>
            <div>flag-icon-bw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-by h1" title="by" id="by"></i>
            <div>flag-icon-by</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-bz h1" title="bz" id="bz"></i>
            <div>flag-icon-bz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ca h1" title="ca" id="ca"></i>
            <div>flag-icon-ca</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cc h1" title="cc" id="cc"></i>
            <div>flag-icon-cc</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cd h1" title="cd" id="cd"></i>
            <div>flag-icon-cd</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cf h1" title="cf" id="cf"></i>
            <div>flag-icon-cf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cg h1" title="cg" id="cg"></i>
            <div>flag-icon-cg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ch h1" title="ch" id="ch"></i>
            <div>flag-icon-ch</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ci h1" title="ci" id="ci"></i>
            <div>flag-icon-ci</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ck h1" title="ck" id="ck"></i>
            <div>flag-icon-ck</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cl h1" title="cl" id="cl"></i>
            <div>flag-icon-cl</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cm h1" title="cm" id="cm"></i>
            <div>flag-icon-cm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cn h1" title="cn" id="cn"></i>
            <div>flag-icon-cn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-co h1" title="co" id="co"></i>
            <div>flag-icon-co</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cr h1" title="cr" id="cr"></i>
            <div>flag-icon-cr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cu h1" title="cu" id="cu"></i>
            <div>flag-icon-cu</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cv h1" title="cv" id="cv"></i>
            <div>flag-icon-cv</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cw h1" title="cw" id="cw"></i>
            <div>flag-icon-cw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cx h1" title="cx" id="cx"></i>
            <div>flag-icon-cx</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cy h1" title="cy" id="cy"></i>
            <div>flag-icon-cy</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-cz h1" title="cz" id="cz"></i>
            <div>flag-icon-cz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-de h1" title="de" id="de"></i>
            <div>flag-icon-de</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-dj h1" title="dj" id="dj"></i>
            <div>flag-icon-dj</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-dk h1" title="dk" id="dk"></i>
            <div>flag-icon-dk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-dm h1" title="dm" id="dm"></i>
            <div>flag-icon-dm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-do h1" title="do" id="do"></i>
            <div>flag-icon-do</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-dz h1" title="dz" id="dz"></i>
            <div>flag-icon-dz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ec h1" title="ec" id="ec"></i>
            <div>flag-icon-ec</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ee h1" title="ee" id="ee"></i>
            <div>flag-icon-ee</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-eg h1" title="eg" id="eg"></i>
            <div>flag-icon-eg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-eh h1" title="eh" id="eh"></i>
            <div>flag-icon-eh</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-er h1" title="er" id="er"></i>
            <div>flag-icon-er</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-es h1" title="es" id="es"></i>
            <div>flag-icon-es</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-et h1" title="et" id="et"></i>
            <div>flag-icon-et</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-fi h1" title="fi" id="fi"></i>
            <div>flag-icon-fi</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-fj h1" title="fj" id="fj"></i>
            <div>flag-icon-fj</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-fk h1" title="fk" id="fk"></i>
            <div>flag-icon-fk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-fm h1" title="fm" id="fm"></i>
            <div>flag-icon-fm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-fo h1" title="fo" id="fo"></i>
            <div>flag-icon-fo</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-fr h1" title="fr" id="fr"></i>
            <div>flag-icon-fr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ga h1" title="ga" id="ga"></i>
            <div>flag-icon-ga</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gb h1" title="gb" id="gb"></i>
            <div>flag-icon-gb</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gd h1" title="gd" id="gd"></i>
            <div>flag-icon-gd</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ge h1" title="ge" id="ge"></i>
            <div>flag-icon-ge</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gf h1" title="gf" id="gf"></i>
            <div>flag-icon-gf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gg h1" title="gg" id="gg"></i>
            <div>flag-icon-gg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gh h1" title="gh" id="gh"></i>
            <div>flag-icon-gh</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gi h1" title="gi" id="gi"></i>
            <div>flag-icon-gi</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gl h1" title="gl" id="gl"></i>
            <div>flag-icon-gl</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gm h1" title="gm" id="gm"></i>
            <div>flag-icon-gm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gn h1" title="gn" id="gn"></i>
            <div>flag-icon-gn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gp h1" title="gp" id="gp"></i>
            <div>flag-icon-gp</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gq h1" title="gq" id="gq"></i>
            <div>flag-icon-gq</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gr h1" title="gr" id="gr"></i>
            <div>flag-icon-gr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gs h1" title="gs" id="gs"></i>
            <div>flag-icon-gs</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gt h1" title="gt" id="gt"></i>
            <div>flag-icon-gt</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gu h1" title="gu" id="gu"></i>
            <div>flag-icon-gu</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gw h1" title="gw" id="gw"></i>
            <div>flag-icon-gw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-gy h1" title="gy" id="gy"></i>
            <div>flag-icon-gy</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-hk h1" title="hk" id="hk"></i>
            <div>flag-icon-hk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-hm h1" title="hm" id="hm"></i>
            <div>flag-icon-hm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-hn h1" title="hn" id="hn"></i>
            <div>flag-icon-hn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-hr h1" title="hr" id="hr"></i>
            <div>flag-icon-hr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ht h1" title="ht" id="ht"></i>
            <div>flag-icon-ht</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-hu h1" title="hu" id="hu"></i>
            <div>flag-icon-hu</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-id h1" title="id" id="id"></i>
            <div>flag-icon-id</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ie h1" title="ie" id="ie"></i>
            <div>flag-icon-ie</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-il h1" title="il" id="il"></i>
            <div>flag-icon-il</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-im h1" title="im" id="im"></i>
            <div>flag-icon-im</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-in h1" title="in" id="in"></i>
            <div>flag-icon-in</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-io h1" title="io" id="io"></i>
            <div>flag-icon-io</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-iq h1" title="iq" id="iq"></i>
            <div>flag-icon-iq</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ir h1" title="ir" id="ir"></i>
            <div>flag-icon-ir</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-is h1" title="is" id="is"></i>
            <div>flag-icon-is</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-it h1" title="it" id="it"></i>
            <div>flag-icon-it</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-je h1" title="je" id="je"></i>
            <div>flag-icon-je</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-jm h1" title="jm" id="jm"></i>
            <div>flag-icon-jm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-jo h1" title="jo" id="jo"></i>
            <div>flag-icon-jo</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-jp h1" title="jp" id="jp"></i>
            <div>flag-icon-jp</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ke h1" title="ke" id="ke"></i>
            <div>flag-icon-ke</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-kg h1" title="kg" id="kg"></i>
            <div>flag-icon-kg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-kh h1" title="kh" id="kh"></i>
            <div>flag-icon-kh</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ki h1" title="ki" id="ki"></i>
            <div>flag-icon-ki</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-km h1" title="km" id="km"></i>
            <div>flag-icon-km</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-kn h1" title="kn" id="kn"></i>
            <div>flag-icon-kn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-kp h1" title="kp" id="kp"></i>
            <div>flag-icon-kp</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-kr h1" title="kr" id="kr"></i>
            <div>flag-icon-kr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-kw h1" title="kw" id="kw"></i>
            <div>flag-icon-kw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ky h1" title="ky" id="ky"></i>
            <div>flag-icon-ky</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-kz h1" title="kz" id="kz"></i>
            <div>flag-icon-kz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-la h1" title="la" id="la"></i>
            <div>flag-icon-la</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-lb h1" title="lb" id="lb"></i>
            <div>flag-icon-lb</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-lc h1" title="lc" id="lc"></i>
            <div>flag-icon-lc</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-li h1" title="li" id="li"></i>
            <div>flag-icon-li</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-lk h1" title="lk" id="lk"></i>
            <div>flag-icon-lk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-lr h1" title="lr" id="lr"></i>
            <div>flag-icon-lr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ls h1" title="ls" id="ls"></i>
            <div>flag-icon-ls</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-lt h1" title="lt" id="lt"></i>
            <div>flag-icon-lt</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-lu h1" title="lu" id="lu"></i>
            <div>flag-icon-lu</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-lv h1" title="lv" id="lv"></i>
            <div>flag-icon-lv</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ly h1" title="ly" id="ly"></i>
            <div>flag-icon-ly</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ma h1" title="ma" id="ma"></i>
            <div>flag-icon-ma</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mc h1" title="mc" id="mc"></i>
            <div>flag-icon-mc</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-md h1" title="md" id="md"></i>
            <div>flag-icon-md</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-me h1" title="me" id="me"></i>
            <div>flag-icon-me</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mf h1" title="mf" id="mf"></i>
            <div>flag-icon-mf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mg h1" title="mg" id="mg"></i>
            <div>flag-icon-mg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mh h1" title="mh" id="mh"></i>
            <div>flag-icon-mh</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mk h1" title="mk" id="mk"></i>
            <div>flag-icon-mk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ml h1" title="ml" id="ml"></i>
            <div>flag-icon-ml</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mm h1" title="mm" id="mm"></i>
            <div>flag-icon-mm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mn h1" title="mn" id="mn"></i>
            <div>flag-icon-mn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mo h1" title="mo" id="mo"></i>
            <div>flag-icon-mo</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mp h1" title="mp" id="mp"></i>
            <div>flag-icon-mp</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mq h1" title="mq" id="mq"></i>
            <div>flag-icon-mq</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mr h1" title="mr" id="mr"></i>
            <div>flag-icon-mr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ms h1" title="ms" id="ms"></i>
            <div>flag-icon-ms</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mt h1" title="mt" id="mt"></i>
            <div>flag-icon-mt</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mu h1" title="mu" id="mu"></i>
            <div>flag-icon-mu</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mv h1" title="mv" id="mv"></i>
            <div>flag-icon-mv</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mw h1" title="mw" id="mw"></i>
            <div>flag-icon-mw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mx h1" title="mx" id="mx"></i>
            <div>flag-icon-mx</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-my h1" title="my" id="my"></i>
            <div>flag-icon-my</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-mz h1" title="mz" id="mz"></i>
            <div>flag-icon-mz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-na h1" title="na" id="na"></i>
            <div>flag-icon-na</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-nc h1" title="nc" id="nc"></i>
            <div>flag-icon-nc</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ne h1" title="ne" id="ne"></i>
            <div>flag-icon-ne</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-nf h1" title="nf" id="nf"></i>
            <div>flag-icon-nf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ng h1" title="ng" id="ng"></i>
            <div>flag-icon-ng</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ni h1" title="ni" id="ni"></i>
            <div>flag-icon-ni</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-nl h1" title="nl" id="nl"></i>
            <div>flag-icon-nl</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-no h1" title="no" id="no"></i>
            <div>flag-icon-no</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-np h1" title="np" id="np"></i>
            <div>flag-icon-np</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-nr h1" title="nr" id="nr"></i>
            <div>flag-icon-nr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-nu h1" title="nu" id="nu"></i>
            <div>flag-icon-nu</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-nz h1" title="nz" id="nz"></i>
            <div>flag-icon-nz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-om h1" title="om" id="om"></i>
            <div>flag-icon-om</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pa h1" title="pa" id="pa"></i>
            <div>flag-icon-pa</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pe h1" title="pe" id="pe"></i>
            <div>flag-icon-pe</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pf h1" title="pf" id="pf"></i>
            <div>flag-icon-pf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pg h1" title="pg" id="pg"></i>
            <div>flag-icon-pg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ph h1" title="ph" id="ph"></i>
            <div>flag-icon-ph</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pk h1" title="pk" id="pk"></i>
            <div>flag-icon-pk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pl h1" title="pl" id="pl"></i>
            <div>flag-icon-pl</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pm h1" title="pm" id="pm"></i>
            <div>flag-icon-pm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pn h1" title="pn" id="pn"></i>
            <div>flag-icon-pn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pr h1" title="pr" id="pr"></i>
            <div>flag-icon-pr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ps h1" title="ps" id="ps"></i>
            <div>flag-icon-ps</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pt h1" title="pt" id="pt"></i>
            <div>flag-icon-pt</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-pw h1" title="pw" id="pw"></i>
            <div>flag-icon-pw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-py h1" title="py" id="py"></i>
            <div>flag-icon-py</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-qa h1" title="qa" id="qa"></i>
            <div>flag-icon-qa</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-re h1" title="re" id="re"></i>
            <div>flag-icon-re</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ro h1" title="ro" id="ro"></i>
            <div>flag-icon-ro</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-rs h1" title="rs" id="rs"></i>
            <div>flag-icon-rs</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ru h1" title="ru" id="ru"></i>
            <div>flag-icon-ru</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-rw h1" title="rw" id="rw"></i>
            <div>flag-icon-rw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sa h1" title="sa" id="sa"></i>
            <div>flag-icon-sa</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sb h1" title="sb" id="sb"></i>
            <div>flag-icon-sb</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sc h1" title="sc" id="sc"></i>
            <div>flag-icon-sc</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sd h1" title="sd" id="sd"></i>
            <div>flag-icon-sd</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-se h1" title="se" id="se"></i>
            <div>flag-icon-se</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sg h1" title="sg" id="sg"></i>
            <div>flag-icon-sg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sh h1" title="sh" id="sh"></i>
            <div>flag-icon-sh</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-si h1" title="si" id="si"></i>
            <div>flag-icon-si</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sj h1" title="sj" id="sj"></i>
            <div>flag-icon-sj</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sk h1" title="sk" id="sk"></i>
            <div>flag-icon-sk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sl h1" title="sl" id="sl"></i>
            <div>flag-icon-sl</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sm h1" title="sm" id="sm"></i>
            <div>flag-icon-sm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sn h1" title="sn" id="sn"></i>
            <div>flag-icon-sn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-so h1" title="so" id="so"></i>
            <div>flag-icon-so</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sr h1" title="sr" id="sr"></i>
            <div>flag-icon-sr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ss h1" title="ss" id="ss"></i>
            <div>flag-icon-ss</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-st h1" title="st" id="st"></i>
            <div>flag-icon-st</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sv h1" title="sv" id="sv"></i>
            <div>flag-icon-sv</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sx h1" title="sx" id="sx"></i>
            <div>flag-icon-sx</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sy h1" title="sy" id="sy"></i>
            <div>flag-icon-sy</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-sz h1" title="sz" id="sz"></i>
            <div>flag-icon-sz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tc h1" title="tc" id="tc"></i>
            <div>flag-icon-tc</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-td h1" title="td" id="td"></i>
            <div>flag-icon-td</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tf h1" title="tf" id="tf"></i>
            <div>flag-icon-tf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tg h1" title="tg" id="tg"></i>
            <div>flag-icon-tg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-th h1" title="th" id="th"></i>
            <div>flag-icon-th</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tj h1" title="tj" id="tj"></i>
            <div>flag-icon-tj</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tk h1" title="tk" id="tk"></i>
            <div>flag-icon-tk</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tl h1" title="tl" id="tl"></i>
            <div>flag-icon-tl</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tm h1" title="tm" id="tm"></i>
            <div>flag-icon-tm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tn h1" title="tn" id="tn"></i>
            <div>flag-icon-tn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-to h1" title="to" id="to"></i>
            <div>flag-icon-to</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tr h1" title="tr" id="tr"></i>
            <div>flag-icon-tr</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tt h1" title="tt" id="tt"></i>
            <div>flag-icon-tt</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tv h1" title="tv" id="tv"></i>
            <div>flag-icon-tv</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tw h1" title="tw" id="tw"></i>
            <div>flag-icon-tw</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-tz h1" title="tz" id="tz"></i>
            <div>flag-icon-tz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ua h1" title="ua" id="ua"></i>
            <div>flag-icon-ua</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ug h1" title="ug" id="ug"></i>
            <div>flag-icon-ug</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-um h1" title="um" id="um"></i>
            <div>flag-icon-um</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-us h1" title="us" id="us"></i>
            <div>flag-icon-us</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-uy h1" title="uy" id="uy"></i>
            <div>flag-icon-uy</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-uz h1" title="uz" id="uz"></i>
            <div>flag-icon-uz</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-va h1" title="va" id="va"></i>
            <div>flag-icon-va</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-vc h1" title="vc" id="vc"></i>
            <div>flag-icon-vc</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ve h1" title="ve" id="ve"></i>
            <div>flag-icon-ve</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-vg h1" title="vg" id="vg"></i>
            <div>flag-icon-vg</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-vi h1" title="vi" id="vi"></i>
            <div>flag-icon-vi</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-vn h1" title="vn" id="vn"></i>
            <div>flag-icon-vn</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-vu h1" title="vu" id="vu"></i>
            <div>flag-icon-vu</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-wf h1" title="wf" id="wf"></i>
            <div>flag-icon-wf</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ws h1" title="ws" id="ws"></i>
            <div>flag-icon-ws</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-ye h1" title="ye" id="ye"></i>
            <div>flag-icon-ye</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-yt h1" title="yt" id="yt"></i>
            <div>flag-icon-yt</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-za h1" title="za" id="za"></i>
            <div>flag-icon-za</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-zm h1" title="zm" id="zm"></i>
            <div>flag-icon-zm</div>
          </b-col>
          <b-col class="mb-5" cols="3" sm="2">
            <i class="flag-icon flag-icon-zw h1" title="zw" id="zw"></i>
            <div>flag-icon-zw</div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'flags'
}
</script>



// WEBPACK FOOTER //
// src/views/base/icons/Flags.vue